/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_CopyInputs */

const en_friends_copy = /** @type {(inputs: Friends_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

const de_friends_copy = /** @type {(inputs: Friends_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopieren`)
};

/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Friends_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_copy = /** @type {((inputs?: Friends_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_copy(inputs)
	return en_friends_copy(inputs)
});